import React from 'react'

function PaymentsComponent() {
  return (
    <div className='wrapper'>
        <div className="container">
          <h4>Make your Payments Here</h4>
        </div>
    </div>
  )
}

export default PaymentsComponent